export const NEWS = {
  BASE_PATH: "/others/news/",
  ADD_PATH() {
    return this.BASE_PATH + "add";
  },
  EDIT_PATH(id: string | number) {
    return this.BASE_PATH + id + "/edit";
  },
  ADD_BUTTON_TITLE: "Add New News",
  LIST_PAGE_TITLE: "News List",
  ADD_NEW_TITLE: "Add New News",
  EDIT_NEW_TITLE: "Edit News",
  GET_ALL: "/cms/news/list",
  GET_ONE: "/cms/news/edit/",
  CREATE: "/cms/news/create",
  UPDATE: "/cms/news/update/",
  DELETE: "/cms/news/delete/",
};
